import api from '../../utils/api';
import { OperatorsActions } from '../reducers/operators';
import { alertError, alertSuccess } from './alert';

export const getOperatorContacts = () => async (dispatch, getState) => {
  const { retailerId } = getState().role;
  const {
    supplier: { id: supplierId },
  } = getState().activation;

  dispatch({ type: OperatorsActions.loading, payload: { contacts: true } });

  try {
    const response = await api.get(`/retailers/${retailerId}/suppliers/${supplierId}/users`);
    if (!response.data?.success) {
      dispatch(alertError('Error getting contacts'));
      dispatch({ type: OperatorsActions.contacts, payload: [] });
      return;
    }

    dispatch({ type: OperatorsActions.contacts, payload: response.data?.users || [] });
  } catch {
    dispatch(alertError('Error getting contacts'));
  } finally {
    dispatch({ type: OperatorsActions.loading, payload: { contacts: false } });
  }
};

export const getOperatorWarehouses = () => async (dispatch, getState) => {
  const { retailerId } = getState().role;
  const {
    supplier: { id: supplierId },
  } = getState().activation;

  dispatch({ type: OperatorsActions.loading, payload: { warehouses: true } });

  try {
    const response = await api.get(`/retailers/${retailerId}/suppliers/${supplierId}/warehouses`);
    if (!response.data?.success) {
      dispatch(alertError('Error getting warehouses'));
      dispatch({ type: OperatorsActions.warehouses, payload: [] });
      return;
    }

    dispatch({ type: OperatorsActions.warehouses, payload: response.data.warehouses || [] });
  } catch {
    dispatch(alertError('Error getting warehouses'));
  } finally {
    dispatch({ type: OperatorsActions.loading, payload: { warehouses: false } });
  }
};

export const updateOperatorConfiguration = (data) => async (dispatch, getState) => {
  const { retailerId } = getState().role;
  const {
    supplier: { id: supplierId },
  } = getState().activation;

  dispatch({ type: OperatorsActions.loading, payload: { submit: true } });

  try {
    await api.put(`/suppliers/${supplierId}/retailers/${retailerId}`, data);

    dispatch({ type: OperatorsActions.configuration, payload: supplierRetailerDataToConfiguration(data) });
    dispatch(alertSuccess('Seller Configuration Updated'));
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch({ type: OperatorsActions.loading, payload: { submit: false } });
  }
};

export function supplierRetailerDataToConfiguration(data) {
  return {
    carrier: data.replenishment_shipper_account_type
      ? {
          account: data.replenishment_shipper_account,
          carrier: data.replenishment_shipper_account_type,
        }
      : null,
    invoice: {
      enabled: !!data.ecommerce_send_invoice,
      value: data.ecommerce_invoice_net_plus,
    },
    commission: data.operator_commission,
    refundFee: parseFloat(Number(data.refund_cost_formula) / 100) || 0,
    handlingFee: data.handling_fee_formula
      ? {
          type: data.handling_fee_formula.type,
          formula: parseFloat(Number(data.handling_fee_formula.formula) / 100),
        }
      : null,
    paymentCycle: data.payment_cycle,
  };
}
